import React from "react";
import InterpolTable from "./InterpolTable/InterpolTable";

export default function InterpolCard(props) {
    const { interpol_data } = props
    const hasSource = Object.keys(interpol_data?.source || {}).length > 0;
    if (!hasSource) return null;
    return (
        <div style={{width: "100%", border: '1px solid #dedede', borderRadius: '8px', padding: '16px'}}>
            <p style={{fontSize: "14px", fontWeight: "bold", margin: "0 0 16px 0", padding: 0, color: '#0b1f82'}}>
                Interpol - Match encontrado
            </p>
            <InterpolTable interpol_data={interpol_data.source} />
        </div>
    )
}
